import React from 'react';
import { Image } from 'semantic-ui-react';
import { visa, vi, mastercard, amex, discover, maestro, paypal, rupay, diner, diners, dinr, dinrs } from '../../cardimg';
import { isMobile } from 'react-device-detect';

const cardMap = { visa, vi, mastercard, amex, discover, maestro, paypal, rupay, diner, diners, dinr, dinrs };

const CardIcon = (props) => {
  const { card } = props;
  const cardIcon = cardMap[card.cardBrand.toLowerCase()];
  return (
    <Image className="cardIcon" src={cardIcon} alt={card.cardBrand} size="tiny" style={{marginTop: isMobile ? '9px' : '0px'}} />
  );
}

export default CardIcon;